import { VehicleSearchDTO } from "../vehicle-search-details/vehicleSearch.type";
import { processSearchResults } from "../vehicle-search-details/processSearchResults";
import getEnvironment from "../getEnvironment";
import getBuyerAPIDomain from "../getBuyerAPIDomain";
import { TRACKED } from "../constants";

interface DegradedServicesStatusProps {
  degradedServices: boolean;
  totalTracked: number;
}

export const checkDegradedServicesStatus = async (
  authToken: string,
  isToUseAuthZero: boolean,
  isTrackedPage?: boolean
): Promise<DegradedServicesStatusProps> => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
    "Cache-Control": "private, max-age=0, no-cache, no-store",
  };

  if (getEnvironment() === "localhost") {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);

  const getSearchResultsUrl = buyerAPIDomain
    ? new URL(`${buyerAPIDomain.href}/search`, buyerAPIDomain)
    : null;

  if (isTrackedPage) {
    getSearchResultsUrl.searchParams.append("requestOrigin", TRACKED);
  }

  try {
    const res = await fetch(getSearchResultsUrl.href, {
      method: "GET",
      headers,
    });
    if (!res.ok) {
      throw new Error(
        `An error (${res.status}) occurred while fetching the data.`
      );
    }
    const result: VehicleSearchDTO = res.status === 200 && (await res.json());
    const data = processSearchResults(result);

    return {
      degradedServices: data.degradedServices?.length > 0,
      totalTracked: data.totalTracked,
    };
  } catch (e) {
    return null;
  }
};
